import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../base/BaseComponent";
import {Button, Dropdown, Menu, message, Modal} from "antd";
import UploadWall from "../../../components/upload/UploadWall";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import {PIC_TYPE, VIDEO_TYPE} from "../../../constants";
import {checkFileStatus} from "../../../actions/upload";

export default class TaskUpload extends BaseComponent {
    static defaultProps = {
        beforeUpload:()=>{},
        onChange:()=>{},
    };
    static propTypes = {};


    constructor(props) {
        super(props);
        this.state = {
            fileList: []
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    render() {
        let type = {
            "PIC_TYPE": [...PIC_TYPE],
            "VIDEO_TYPE": [...VIDEO_TYPE]
        };
        let accept;
        if(this.props.upLoadType === undefined ){
            accept = "."
        }else{
             accept = "." + type[this.props.upLoadType].join(",.");
        }
        let array = JSON.parse(JSON.stringify(accept)).toLowerCase();
        let arr = array.split(",");
        let newArray = [];
        //打开弹框的时候  过滤掉重复的格式
        arr && arr.length && arr.forEach((item, index) => {
            if (newArray.indexOf(item) > -1) {
            } else {
                newArray.push(item)
            }
        });
        newArray = newArray.toString();
        return (
            <div>
                <UploadWall
                    // fileList={this.state.fileList}
                    ref={uploadWall => this.uploadWall = uploadWall}
                    showUploadDisplayBtn={true}
                    accept={newArray}
                    multiple={true}
                    action="/storage/uploadFile"
                    listType="list"
                    style={{padding: 'unset'}}
                    fileItemComponent={<></>}
                    customRequest={new ChunkUpload({
                        checkFileURL: "/storage/checkFile",
                        checkChunkURL: "/storage/checkChunk",
                        uploadChunkURL: "/storage/uploadChunk",
                        chunkUploadOverURL: "/storage/chunkIsUploadOver",
                        mergeChunksURL: "/storage/mergeChunk",
                        checkFileStatus:(obj, newFile,fileList)=>{
                              // this.props.uploadOnOk(obj);
                        }
                    }).start}
                    uploadBtnName={<Button type="primary">{this.props.name}</Button>}
                    beforeUpload={this.beforeUpload}
                    onChange={(obj)=>{
                        this.props.uploadOnOk(obj);
                        // this.setState({})
                        // console.log("-----------------over----------");
                    }}
                />
            </div>
        )
    }

    //上传之前
    beforeUpload = async file => {
        let type = {
            "PIC_TYPE": PIC_TYPE,
            "VIDEO_TYPE": VIDEO_TYPE
        };
        let accept;
        if(this.props.upLoadType === undefined ){
            accept = ''
        }else{
            accept = type[this.props.upLoadType];
        }
        let newRes = accept.find(item => file.name.endsWith(item));
        let sizeValue = file.size;
        let maxSize = this.sysConfigGetValueByKey("task_upload_video_max_size", 500)
        return new Promise((resolve, reject) => {
            if (newRes) {
                if (sizeValue === 0) {
                    message.error(`空文件不能上传！`);
                    reject();
                }
                if (sizeValue / 1024 / 1024 > maxSize) {
                    message.error(`文件不能超过${maxSize}MB！`);
                    reject();
                } else {
                    // resolve();
                    let url = '/cm-sites-business/bd/busTask/getById/';
                    this.request({
                        url: "" + url + this.props.taskId,
                        method: "post",
                        body: {
                            "showRef": [
                                "taskReporterIds",
                                "clueId",
                                "topicSelectionId"
                            ]
                        },
                        contentType: 'json',
                        callBack: (res) => {
                            let data  =res&&res.taskReporterObjs?res.taskReporterObjs:[];
                            let myRole=data&&data.length?data.filter(item=>(item.reporter.name==window.currentUser.name && item.reporter.account==window.currentUser.account&&item.reporter.currentDept?.id===window.currentUser.defaultInfo?.dept?.id)):'';
                            if(myRole&&myRole.length){
                                resolve()

                            }else{
                              this.props.closeNoAuth&&this.props.closeNoAuth()
                                // this.props.callBack&&this.props.callBack();

                            }

                        }
                    });
                }
            } else {
                message.destroy();
                message.error('暂不支持该文件类型！');
                reject();
            }
        });





    };
}